import { useCallback, useRef, useState } from "react"

// function useHookWithRefCallback() {
//   const ref = useRef(null)
//   const setRef = useCallback((node) => {
//     if (ref.current) {
//       // Make sure to cleanup any events/references added to the last instance
//     }

//     if (node) {
//       // Check if a node is actually passed. Otherwise node would be null.
//       // You can now do what you need to, addEventListeners, measure, etc.
//     }

//     // Save a reference to the node
//     ref.current = node
//   }, [])

//   return [setRef, ref]
// }

export default function useInfiniteScroll({
  // hasMore,
  // length,
  reset = false,
  distance = 250,
}) {
  // const scrollContainerRef = useRef()
  // const loaderRef = useRef()
  // const [page, setPage] = useState(0)

  // if (reset && page !== 0) {
  //   setPage(0)
  // }

  // useLayoutEffect(() => {
  //   const loaderNode = loaderRef.current
  //   const scrollContainerNode = scrollContainerRef.current
  //   if (!scrollContainerNode || !loaderNode || !hasMore) return

  //   const options = {
  //     root: scrollContainerNode,
  //     rootMargin: `0px 0px ${distance}px 0px`,
  //   }

  //   let previousY
  //   let previousRatio = 0

  //   const listener = (entries) => {
  //     entries.forEach(
  //       ({ isIntersecting, intersectionRatio, boundingClientRect = {} }) => {
  //         const { y } = boundingClientRect
  //         if (
  //           isIntersecting &&
  //           intersectionRatio >= previousRatio &&
  //           (!previousY || y < previousY)
  //         ) {
  //           setPage((page) => page + 1)
  //         }
  //         previousY = y
  //         previousRatio = intersectionRatio
  //       },
  //     )
  //   }

  //   const observer = new IntersectionObserver(listener, options)
  //   observer.observe(loaderNode)

  //   return () => observer.disconnect()
  // }, [hasMore, distance])

  const [page, setPage] = useState(0)

  if (reset && page !== 0) {
    setPage(0)
  }

  // const [setRef, loaderRef] = useHookWithRefCallback()

  let loaderRef = useRef(null)

  const scrollObserver = useCallback(
    (node) => {
      const onIntersection = (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setPage((page) => ++page)
          }
        }
      }

      // new IntersectionObserver((entries) => {
      //   entries.forEach((en) => {
      //     if (en.intersectionRatio > 0) {
      //       setPage((page) => page + 1)
      //     }
      //   })
      // }).observe(node)

      const observer = new IntersectionObserver(onIntersection, {
        threshold: 1,
      })

      observer.observe(node)

      //       const onIntersection = ([{isIntersecting, target}]) =>
      //   isIntersecting && (target.style.backgroundColor = 'green');

      // const io = new IntersectionObserver(onIntersection, {threshold: 1})
    },
    [setPage],
  )

  // useEffect(() => {
  //   // if (loaderRef.current) {
  //   //   scrollObserver(loaderRef.current)
  //   // }
  // }, [scrollObserver, loaderRef])

  const setLoaderRef = useCallback(
    (node) => {
      loaderRef.current = node
      if (loaderRef.current) {
        scrollObserver(loaderRef.current)
      }
    },
    [loaderRef, scrollObserver],
  )

  return [page, setLoaderRef]
}
